module.exports = __webpack_public_path__ + "static/media/insertion-points.531d57be.gif";